//Axios(ajax) 配置文件
import axios from 'axios';

const config = {
    baseURL: '',  // 设置请求的基本URL
    timeout: 5000,  // 设置请求超时时间
    withCredentials: false
}

// config.baseURL = globals.$ShopopeeUrl

//配置开发环境
// if (process.env.NODE_ENV === 'development') {
//     config.baseURL = 'http://localhost:8080';
// }
//
// // 配置生产环境
// if (process.env.NODE_ENV === 'production') {
//     config.baseURL = 'http://shopopee.com';
// }

// 创建一个新的axios实例
const Axios = axios.create(config);

// 添加请求拦截器
Axios.interceptors.request.use(
    (config) => {
        // 在发送请求之前做一些处理，比如添加请求头
        // config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
Axios.interceptors.response.use(
    (response) => {
        // 对响应数据做一些处理
        return response.data;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default Axios;